import axios, { AxiosResponse } from 'axios';
import { ICourse, ICourseDay, IProgram, ICourseType, IProducttype, ICourseRelated, ISiteMap, IContent, ISharePointContent } from './components/DataTable';
import { ISharePointContentWithPriority } from './components/WASPanel';
import { ICourseRegistration } from './components/RegistrationsTable';

// The API is served from the same origin as the SPA (see server/Program.cs),
// so this always targets wherever the page is actually running — no more
// hardcoding a specific azurewebsites.net hostname that can drift from the
// real one.
const url = window.location.href.indexOf("localhost") !== -1 ? "https://localhost:7276/" : `${window.location.origin}/`

export async function getPrograms(accessToken: string, inaktiv: boolean, all: boolean) {
    return axios.get(url + "programs", {
        headers: {
            Authorization: "Bearer " + accessToken,
        },
        params: {
            inaktiv: inaktiv,
            all: all
        }
    })
        .catch((error: any) => console.log(error));
}
export async function getTypes(accessToken: string) {
    return axios.get(url + "types", {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => console.log(error));
}

export async function getCourseTypes(accessToken: string, id: number) {
    return await axios.get(url + "types/" + id.toString(), {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => { console.log(error); return null; });
}

export async function getCourseDates(accessToken: string, id: number) {
    return axios.get(url + "courses/" + id.toString(), {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => console.log(error));
}

export async function getCourseDays(accessToken: string, courseId: number) {
    return axios.get(url + "days/" + courseId.toString(), {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => console.log(error));
}

export async function getAllCourseRegistrations(accessToken: string) {
    return axios.get(url + "registration", {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => {
            console.log(error)
        });
}
export async function getPeriodCourseRegistrations(accessToken: string, postObject: any) {
    return axios.post(url + "registration/period", postObject, {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => console.log(error));
}

export async function getLanguages(accessToken: string) {
    return axios.get(url + "languages", {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => {
            console.log(error);
            return [];
        });;
}

export async function getLevels(accessToken: string) {
    return axios.get(url + "levels", {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => {
            console.log(error);
            return [];
        });
}

export async function getCourseTemplates(accessToken: string) {
    return axios.get(url + "templates", {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => {
            console.log(error);
            return [];
        });
}

export async function getProducttypes(accessToken: string) {
    return axios.get(url + "producttypes", {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => {
            console.log(error);
            return null;
        });
}

export async function getProgramgroups(accessToken: string) {
    return axios.get(url + "programgroups", {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => {
            console.log(error);
            return [];
        });
}

export async function getProgramRelations(accessToken: string, programId: number) {
    return await axios.get(url + "programCourses/" + programId.toString(), {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => {
            console.log(error);
            return null;
        });
}

export async function getCourseTypeRelatedCourses(accessToken: string, courseId: number) {
    return await axios.get(url + "relatedCoursesTypes/" + courseId.toString(), {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => {
            console.log(error);
            return null;
        });
}

// export async function uploadImage(accessToken: string, file: File) {
//     const formData = new FormData();
//     formData.append("file", file);
//     return axios.post(url + "imageUpload", formData, {
//         headers: {
//             Authorization: "Bearer " + accessToken,
//             'Content-Type': 'multipart/form-data'
//         }
//     })
//         .catch((error: any) => console.log(error));
// }

export async function getSiteMap(accessToken: string, SMurl: string) {
    return axios.get(url + "siteMap", {
        headers: {
            Authorization: "Bearer " + accessToken,
        },
        params: {
            SMurl: SMurl
        }
    })
        .catch((error: any) => console.log(error));
}

export async function getWASContent(accessToken: string, SMID: number) {
    return axios.get(url + "wasContent", {
        headers: {
            Authorization: "Bearer " + accessToken,
        },
        params: {
            SMID: SMID
        }
    })
        .catch((error: any) => console.log(error));
}

export async function getSharePointContent(accessToken: string, SCID: number) {
    return axios.get(url + "sharePointContent", {
        headers: {
            Authorization: "Bearer " + accessToken,
        },
        params: {
            SCID: SCID
        }
    })
        .catch((error: any) => console.log(error));
}

export async function getImages(accessToken: string) {
    return axios.get(url + "imageList", {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => {
            console.log(error);
            return null;
        });
}

export async function getNodeIdFromPath(accessToken: string, path: string) {
    return axios.get(url + "nodeId", {
        headers: {
            Authorization: "Bearer " + accessToken,
        },
        params: {
            path: path,
        }
    })
        .catch((error: any) => {
            console.log(error);
            return null;
        });
}

export async function addWASContent(accessToken: string, wasUrl: string, umbracoId: string, sortOrder: number, name: string) {
    return axios.post(url + "newWASContent", { wasUrl, umbracoId, sortOrder, name }, {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => {
            console.log(error);
            return null;
        });
}

export async function updateImage(accessToken: string, path: string, name: string, parentName: string, nodeId: number, fileName: string) {
    return axios.post(url + "mapTopImage", { path, name, parentName, nodeId, fileName }, {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => {
            console.log(error);
            return null;
        });
}

export async function addOrUpdateCourseDate(accessToken: string, course: ICourse) {
    return axios.post(url + "courses", course, {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    });
}
export async function addOrUpdateCourseDay(accessToken: string, day: ICourseDay) {
    return axios.post(url + "day", day, {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => console.log(error));
}

export async function updateCourseContent(accessToken: string, type: ICourseType) {
    return axios.post(url + "type", type, {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => console.log(error));
}

export async function updateRegistrationStatus(accessToken: string, registration: any) {

    return axios.post(url + "registration", registration, {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => console.log(error));
}

export async function updateProgramContent(accessToken: string, program: IProgram) {
    return axios.post(url + "program", program, {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => console.log(error));
}

export async function createNewCourseType(accessToken: string, type: ICourseType) {
    return axios.post(url + "newType", type, {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => console.log(error));
}

export async function createNewProgram(accessToken: string, program: IProgram) {
    return axios.post(url + "newProgram", program, {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => console.log(error));
}

export async function createCourseProgramRelation(accessToken: string, courseId: number, programId: number) {
    return axios.post(url + "program/" + programId.toString() + "/course/" + courseId.toString(), {}, {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => console.log(error));
}

export async function updateProducttype(accessToken: string, producttype: IProducttype) {
    return axios.post(url + "producttype", producttype, {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => console.log(error));
}

export async function createProducttype(accessToken: string, producttype: IProducttype) {
    return axios.post(url + "newProducttype", producttype, {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => console.log(error));
}

export async function createCourseTypeBeforeAfter(accessToken: string, relatedCourse: ICourseRelated) {
    return axios.post(url + "relatedCourseType", relatedCourse, {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => console.log(error));
}

export async function addDatasheetLayout(accessToken: string, kursustypeId: number) {
    return axios.post(url + "addDatasheetLayout/" + kursustypeId.toString(), {}, {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => console.log(error));
}

export async function updateWASContent(accessToken: string, smid: number, scid: number, coPriority: number, coActive: boolean) {
    return axios.put(url + "updateWASContent", { smid, scid, coActive, coPriority }, {
        headers: {
            Authorization: "Bearer " + accessToken,
        },
    }
    ).catch((error: any) => {
        console.log(error);
        return null;
    });
}

export async function deleteCourseTypeBeforeAfter(accessToken: string, courseId: number, relatedCourseId: number) {
    return axios.delete(url + "relatedCourseType/" + relatedCourseId.toString() + "/" + courseId.toString(), {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => console.log(error));
}

export async function deleteCourseProgramRelation(accessToken: string, courseId: number, programId: number) {
    return axios.delete(url + "program/" + programId.toString() + "/course/" + courseId.toString(), {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => console.log(error));
}

export async function deleteCourseDate(accessToken: string, id: number) {
    return axios.delete(url + id.toString(), {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => console.log(error));
}
export async function deleteCourseRegistration(accessToken: string, id: number) {

    return axios.delete(url + "Kurser/registration/" + id.toString(), {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    })
        .catch((error: any) => console.log(error));
}
export async function deletePeoplenetCourseRegistration(data: any) {

    return axios.put('https://peoplenet.dk/wp-json/pncourses/v1/delete-submission', data)
        .catch((error: any) => console.log("Der skete et problem med at slette en tilmelding i Peoplenet endpoint. Error: " + error));
}
export async function getPeoplenetPeriodCourseRegistration(data: any) {

    return axios.post('https://peoplenet.dk/wp-json/pncourses/v1/get-period-submission', data)
        .catch((error: any) => console.log("Der skete et problem med at hente tilmeldinger i Peoplenet endpoint for denne periode. Error: " + error));
}

export async function getAllPeoplenetCourseRegistrations() {
    return axios.get('https://peoplenet.dk/wp-json/pncourses/v1/get-submissions')
        .catch((error: any) => console.log("Der skete et problem med at hente tilmeldinger fra Peoplenet endpoint. Error: " + error));
}

export async function getAllPeoplenetCoursePrices() {
    return axios.get('https://peoplenet.dk/wp-json/pncourses/v1/get-course-prices')
        .catch((error: any) => console.log("Der skete et problem med at hente kursus priser fra Peoplenet endpoint. Error: " + error));
}

export async function updatePeoplenetRegistrationStatus(data: any) {
    return axios.put('https://peoplenet.dk/wp-json/pncourses/v1/post-submission', data)
        .catch((error: any) => console.log("Der skete et problem med at poste en tilmelding til Peoplenet endpoint. Error: " + error));
}

// ------------------------------------------------------------------
// Forecast history fetch — THROWS on either-source failure.
//
// Unlike the rest of this file (which swallows errors into console.log
// and returns undefined), this wrapper rejects on failure so the
// Prognose tab can render an explicit error banner instead of a
// silently-incomplete forecast. See TODOS.md for the broader api.ts
// error-handling refactor.
// ------------------------------------------------------------------

export class ForecastSourceError extends Error {
    source: "4D" | "PeopleNet";
    cause: any;
    constructor(source: "4D" | "PeopleNet", cause: any) {
        super(`Forecast history fetch failed for ${source}`);
        this.source = source;
        this.cause = cause;
        this.name = "ForecastSourceError";
    }
}

export interface ForecastHistoryPeriod {
    startDate: string;
    endDate: string;
}

/**
 * Fetch raw registration history for forecast training from the requested
 * sources. Throws ForecastSourceError if any selected source fails.
 * `firm`: "Alle" fetches both; "4D" only 4D; "PeopleNet" only PeopleNet.
 */
export async function getHistoryForForecast(
    accessToken: string,
    firm: "Alle" | "4D" | "PeopleNet",
    period: ForecastHistoryPeriod
): Promise<{ fourD: any[]; peopleNet: any[] }> {
    const wants4D = firm === "4D" || firm === "Alle";
    const wantsPN = firm === "PeopleNet" || firm === "Alle";

    let fourD: any[] = [];
    let peopleNet: any[] = [];

    if (wants4D) {
        try {
            const response: AxiosResponse = await axios.post(
                url + "registration/period",
                period,
                { headers: { Authorization: "Bearer " + accessToken } }
            );
            fourD = response?.data ?? [];
        } catch (e) {
            throw new ForecastSourceError("4D", e);
        }
    }

    if (wantsPN) {
        try {
            const response: AxiosResponse = await axios.post(
                'https://peoplenet.dk/wp-json/pncourses/v1/get-period-submission',
                period
            );
            peopleNet = response?.data ?? [];
        } catch (e) {
            throw new ForecastSourceError("PeopleNet", e);
        }
    }

    return { fourD, peopleNet };
}

export async function getDatasheetHeadlines(accessToken: string) {
    return axios.get(url + "datasheetHeadlines", {
        headers: {
            Authorization: "Bearer " + accessToken,
        }
    });
}

export async function getDatasheetLayout(
    accessToken: string,
    kursustypeId: number
) {
    return axios.get(
        url + "datasheetLayout/" + kursustypeId.toString(),
        {
            headers: {
                Authorization: "Bearer " + accessToken,
            }
        }
    );
}

export async function updateDatasheetLayout(
    accessToken: string,
    kursustypeId: number,
    dshId: number
) {
    return axios.put(
        url + "datasheetLayout/" + kursustypeId.toString(),
        dshId,
        {
            headers: {
                Authorization: "Bearer " + accessToken,
                "Content-Type": "application/json",
            }
        }
    );
}